import {useState} from "react"
import {createModel} from "hox"

function ShowDataList() {
    const [status, setStatus] = useState(false)
    const init = () => {
        setStatus(true)
    }

    const toTrue = () => {
        setStatus(true)
    }
    const toFalse = () => {
        setStatus(false)
    }
    return {
        value: status,
        init,
        toTrue,
        toFalse,
    }
}

export default createModel(ShowDataList)
